import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconArrowUpLeft: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconArrowUpLeft"><Path d="M5.5 15.5V5.5H15.5" stroke="currentColor" strokeLinecap="square"/><Path d="M6 6L18 18" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconArrowUpLeft;
